module.exports = __webpack_public_path__ + "img/idcardBackUrl.b4e772ca.png";